import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import "primeicons/primeicons.css";
import "../../styles/custom-tabview.css";
import axios from "axios";

import NouvellesFiches from "./nouvellesFiches";
import SuivisFiches from "./suivisFiches";
import ValidesFiches from "./validesFiches";
import RealisesFiches from "./realisesFiches";
import ToutesFiches from "./toutesLead";
import AbandonsFiche from "./abandons";
import DashboardLeads from "./dashboardLead";
import Relances from "./relances";
const apiUrl = process.env.REACT_APP_API_URL;

const TABS = [
  { label: "Nouvelles", key: "nouvelles" },
  { label: "Relances", key: "relance" },
  { label: "Suivis",    key: "en_suivi" },
  { label: "Validés",   key: "valides" },
  { label: "Réalisés",  key: "realises" },
  { label: "Abandons",  key: "abandons" },
  { label: "Tous",      key: "toutes" },
];

export default function LeadsList() {
  const [activeIndex, setActiveIndex] = useState(() => {
    const s = localStorage.getItem("activeTabIndexLeads");
    return s !== null ? parseInt(s) : 0;
  });

  const [counters, setCounters] = useState({
    nouvelles: 0, en_suivi: 0, valides: 0,
    realises: 0, abandons: 0, toutes: 0,
  });

  const [globalSearch, setGlobalSearch] = useState("");

  const changeTab = (index) => {
    setActiveIndex(index);
    localStorage.setItem("activeTabIndexLeads", index);
  };

  useEffect(() => {
    axios.get(`${apiUrl}/IHM/api/lead.php?pannel=true`)
      .then(res => setCounters(res.data))
      .catch(err => console.error("Erreur compteurs:", err));
  }, [activeIndex]);


  return (
    <>
      <DashboardLeads />

      <div style={{ 
  overflowX: "auto", 
  overflowY: "visible",
  WebkitOverflowScrolling: "touch", 
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  position: "relative",
  zIndex: 1,
}}>

        <div className="flex flex-column md:flex-row justify-content-between md:align-items-center p-2 gap-3">

          <div style={{ overflowX: "auto", WebkitOverflowScrolling: "touch", scrollbarWidth: "none" }}>
            <div style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap", gap: "4px", minWidth: "max-content" }}>
              {TABS.map((tab, i) => {
                const isActive = i === activeIndex;
                return (
                  <div
                    key={i}
                    onPointerDown={() => changeTab(i)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "0 12px",
                      height: "35px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      flexShrink: 0,
                      backgroundColor: isActive ? "#0d0d0d" : "transparent",
                      touchAction: "manipulation",
                      WebkitTapHighlightColor: "transparent",
                      userSelect: "none",
                    }}
                  >
                    <span style={{
                      color: isActive ? "#f5c542" : "#6b6b6b",
                      fontWeight: isActive ? 700 : 500,
                      fontSize: "13px",
                    }}>
                      {tab.label}
                    </span>
                    <span style={{
                      marginLeft: "6px",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      borderRadius: "50%",
                      fontWeight: "bold",
                      fontSize: "10px",
                      width: "18px", height: "18px",
                      backgroundColor: isActive ? "#f5c542" : "transparent",
                      color: isActive ? "#0d0d0d" : "#9a9a98",
                    }}>
                      {counters[tab.key] ?? 0}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Search */}
          <div className="w-full md:w-auto">
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search" />
              <InputText
                value={globalSearch}
                onChange={(e) => setGlobalSearch(e.target.value)}
                placeholder="Rechercher un client..."
                className="w-full md:w-20rem"
              />
            </IconField>
          </div>
        </div>

        {/* CONTENU */}
        <div style={{ padding: "1rem 0 0 0" }}>
          {activeIndex === 0 && <NouvellesFiches searchTerm={globalSearch} />}
          {activeIndex === 1 && <Relances searchTerm={globalSearch} />}
          {activeIndex === 2 && <SuivisFiches    searchTerm={globalSearch} />}
          {activeIndex === 3 && <ValidesFiches   searchTerm={globalSearch} />}
          {activeIndex === 4 && <RealisesFiches  searchTerm={globalSearch} />}
          {activeIndex === 5 && <AbandonsFiche   searchTerm={globalSearch} />}
          {activeIndex === 6 && <ToutesFiches    searchTerm={globalSearch} />}
        </div>

      </div>
    </>
  );
}